import styled from 'styled-components';
import { applyFlexAndCenter } from '@/styles';

export const Wrapper = styled.div`
  margin-left: auto;
  margin-right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.palette.white};
  border-radius: ${({ theme }) => theme.borderRadius.md};
  box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.15);
  padding: ${({ theme }) => `${theme.spacing[8]} ${theme.spacing[8]}`};
  path {
    fill: ${({ theme }) => theme.palette.grays80};
  }
  p {
    padding: 0px 10px;
    color: ${({ theme }) => theme.palette.grays80};
  }
`;

export const ActionBtn = styled.button`
  ${applyFlexAndCenter}
  padding: 0;
`;
